import React from "react";

import CircularProgress from "@material-ui/core/CircularProgress";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  loaderContainer: {
    position: "relative",
    //width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }
}));

const Loader = (props) => {
  const classes = useStyles();
  return (
    <div className={classes.loaderContainer}>
      <CircularProgress thickness={4.6} style={{'color': '#FC8300'}}/>
    </div>
  );
};

export default Loader;
